import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { SERVICE_STATUS } from '@bagonboard/wiseman';

import * as actions from '../../../../../reducers/Service/actions';
import { Dialog } from './components';
import { AddButton, Container } from './style';

const {
  CANCELLED,
  COMPLETED,
  DECLINED,
} = SERVICE_STATUS;

class AddPassenger extends Component {
  state = {
    activeDialog: false,
  };

  onAddPassengerClick = () => {
    this.toggleDialog();
  };

  toggleDialog = () => {
    this.setState(prevState => ({ activeDialog: !prevState.activeDialog }));
  };

  render() {
    const {
      id, isCheckin, paxs, status, updateService,
    } = this.props;
    const { activeDialog } = this.state;

    if (!isCheckin || [COMPLETED, CANCELLED, DECLINED].includes(status)) return null;

    return (
      <Container>
        <AddButton onClick={this.onAddPassengerClick} variant="outlined">
          Add passenger
        </AddButton>
        <Dialog
          id={id}
          open={activeDialog}
          onClose={this.toggleDialog}
          paxs={paxs}
          updateService={updateService}
        />
      </Container>
    );
  }
}
AddPassenger.propTypes = {
  id           : PropTypes.string,
  isCheckin    : PropTypes.bool,
  paxs         : PropTypes.arrayOf(PropTypes.shape({})),
  status       : PropTypes.string,
  updateService: PropTypes.func,
};
AddPassenger.defaultProps = {
  id       : null,
  isCheckin: false,
  paxs     : [],
  status   : null,
  updateService() {},
};

const mapDispatchToProps = dispatch => ({
  updateService: data => dispatch(actions.updateService(data)),
});

export default compose(
  connect(
    undefined,
    mapDispatchToProps,
  ),
)(AddPassenger);
